const config = {
    BACKEND_URL: 'https://backend.prod.gustavus.zensource.site'
  };
  
  export default config;
  